import { useTranslation } from "react-i18next";

import { useMe } from "@/auth/useMe";
import { Card, Field, Page } from "@/components/ui";
import { MailboxCard } from "@/mail/MailboxCard";
import { AudioCheck } from "@/telephony/AudioCheck";

export function Settings() {
  const { t } = useTranslation();
  const { data: me } = useMe();

  return (
    <Page title={t("settings.title")} subtitle={t("settings.subtitle")}>
      <div className="grid gap-4 lg:grid-cols-2">
        <Card title={t("settings.calling")}>
          <div className="space-y-3 p-4 text-sm">
            <dl className="border-2 border-rule">
              {/* Straight from `SellerProfile`, and all there is to see: every
                  call is placed from the browser, so there is no mode to pick.
                  The number is what a client sees and what *Llamar* requires;
                  the mobile is where a client calling that number back rings.
                  A blank one here beats discovering it mid-dial. */}
              <Field label={t("settings.callerId")}>
                {me?.profile?.twilio_caller_id || (
                  <span className="text-brand-700">{t("settings.missing")}</span>
                )}
              </Field>
              <Field label={t("settings.mobile")}>
                {me?.profile?.mobile || (
                  <span className="text-brand-700">{t("settings.missing")}</span>
                )}
              </Field>
            </dl>
          </div>
        </Card>

        <MailboxCard />

        <AudioCheck />
      </div>
    </Page>
  );
}
